import { createReducer } from "redux-create-reducer";

import {
  GET_SCORING_RESULTS_REPORT_ENTRIES,
  GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT,
  SET_SCORING_RESULTS_REPORT_ENTRIES_CURRENT_PAGE,
  SET_SCORING_RESULTS_REPORT_ENTRIES_FILTERS,
  CLEAR_SCORING_RESULTS_REPORT,
  SET_SCORING_RESULTS_ITEMS_PER_PAGE,
  SET_SCORING_RESULTS_NO_ENTRIES_MESSAGE,
} from "../../types";

const initialState = {
  data: [],
  filters: {
    dateFrom: "",
    dateTo: "",
    scoringType: "",
  },
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  entries: [],
  isLoading: false,
  noEntriesMessage: "",
};

const scoringResultsReportEntriesReducer = createReducer(initialState, {
  [SET_SCORING_RESULTS_REPORT_ENTRIES_FILTERS]: (state, { payload }) => ({
    ...initialState,
    filters: { ...state.filters, ...payload },
  }),
  [SET_SCORING_RESULTS_REPORT_ENTRIES_CURRENT_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_SCORING_RESULTS_ITEMS_PER_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT.FULFILLED]: (
    state,
    { payload }
  ) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      count: payload.data,
    },
    isLoading: false,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_SCORING_RESULTS_REPORT_ENTRIES.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [SET_SCORING_RESULTS_NO_ENTRIES_MESSAGE]: (state, { payload }) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
  [CLEAR_SCORING_RESULTS_REPORT]: () => initialState,
});

export default scoringResultsReportEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/scoring-results/scoringResultsReportEntriesReducer.js